import { environment } from 'environments/environment';

export enum TimeMensagem {
    TIME_MENSAGEM  = environment.TIME_MENSAGEM,
    TIME_MENSAGEM_FINANCEIRO = environment.TIME_MENSAGEM_FINANCEIRO,
}
